import { Group, Line } from 'react-konva';

interface ErrorIndicatorProps {
  zoom: number;
  width: number;
  x: number;
  y: number;
}
const ErrorIndicator = ({ zoom, width, x, y }: ErrorIndicatorProps) => {
  const lineWidth = 7 * zoom;
  const lineX = width - lineWidth - 1;
  const lineY = 1;
  return (
    <Group x={x} y={y}>
      <Line
        points={[lineX, lineY, width, lineY, width, lineWidth, lineX, lineY]}
        strokeEnabled={false}
        closed
        // opacity={0.8}
        fill="red"
      />
    </Group>
  );
};

export default ErrorIndicator;
